import { useState } from "react";
import { FaAngleDown, FaAngleUp } from "react-icons/fa6";
import type { SubAccordionItem } from "./interface";

interface SubAccordionProps {
  item: SubAccordionItem;
  defaultOpen?: boolean;
}

export function SubAccordion({ item, defaultOpen = false }: SubAccordionProps) {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <div className=" bg-white ">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="cursor-pointer w-full flex items-center justify-between px-4 py-3 text-left hover:bg-gray-50 transition-colors"
      >
        <div className="flex items-center gap-2">
          <span className="text-[13px] font-medium text-[#68737D]">
            {item.title}
          </span>
          {item.badge && (
            <span className="bg-[#E8F4F8] text-[#1F73B7] text-[11px] font-medium px-2 py-0.5 rounded-full min-w-5 text-center">
              {item.badge}
            </span>
          )}
        </div>
        {isOpen ? (
          <FaAngleUp className="w-4 h-4 text-[#68737D] shrink-0" />
        ) : (
          <FaAngleDown className="w-4 h-4 text-[#68737D] shrink-0" />
        )}
      </button>

      {isOpen && (
        <div className="border-t border-gray-200">
          {/* Conteúdo no mesmo formato do accordion principal */}
          {item.fields && item.values ? (
            <>
              {item.fields.map((field: string, index: number) => (
                <div
                  key={index}
                  className={`grid grid-cols-2 items-start text-[12px] ${
                    index % 2 === 0 ? "bg-white" : "bg-[#F8F9F9]"
                  }`}
                >
                  <div className="text-sm text-[#87929D] py-[9px] px-4">
                    {field}
                  </div>
                  <div className="text-sm py-[9px] px-4">
                    {item.values![index]}
                  </div>
                </div>
              ))}
            </>
          ) : (
            /* Conteúdo customizado (fallback) */
            <div className="bg-white">{item.content}</div>
          )}
        </div>
      )}
    </div>
  );
}
